module.exports = __webpack_public_path__ + "img/game_main_pc_262_off.2ff89785.png";